import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=0df95244&scoped=true&"
var script = {}
import style0 from "./Partners.vue?vue&type=style&index=0&id=0df95244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df95244",
  null
  
)

export default component.exports